import React from 'react'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  async componentWillMount() {
    let uid = await setUidToken(this.props.location.query)
    history.push(`/activity/couples`)
  }
  render() {
    return (
      <div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/couples/index.js